import React from 'react'
import { Document } from '@contentful/rich-text-types'
import { Img } from '@superhi/design'

import { LibraryPostBlockBase } from '../types'
import Caption from '../Caption'

import { Wrapper, Video } from './styles'

export type LibraryPostBlockMedia = LibraryPostBlockBase<
  'blogPostMedia',
  {
    caption: Document
    media: {
      fields: {
        file: {
          contentType: string
          url: string
          details: {
            image?: {
              height: number
              width: number
            }
          }
        }
      }
    }
  }
>

type Props = {
  type: 'image' | 'video'
  url: string
  width?: number
  height?: number
  caption?: Document
}

const LibraryPostBlockMedia: React.FC<Props> = ({ type, url, width, height, caption }) => (
  <Wrapper>
    {type === 'image' ? (
      <Img src={url} width={width} height={height} alt="" lazy />
    ) : (
      <Video src={url} />
    )}
    {caption && <Caption>{caption}</Caption>}
  </Wrapper>
)

export default LibraryPostBlockMedia
